// extracted by mini-css-extract-plugin
module.exports = {"tableFixHead":"Table_tableFixHead__Y9DuX","Table":"Table_Table__QRcej"};